import "./memo-leaf.scss"

export function MemoLeaf({ children }: any) {
    return (
        <div className="memo-leaf">
            <i className="icon-message leading" /> {children}
        </div>
    )
}